import { render, staticRenderFns } from "./LocationsSettings.vue?vue&type=template&id=fffd713a"
import script from "./LocationsSettings.vue?vue&type=script&lang=js"
export * from "./LocationsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports